import React      from "react"

export default React.createContext(
  {
    windowWidth:  35.0,
    windowHeight: 51.10
  }
);
